export const calculatePercentage = (value: number, total: number) => {
  return Math.floor(100 * (value / total));
};

export const calculateNumberFromPercentage = (value: number, total: number) => {
  const candidate = Math.round((value * total) / 100);
  if (calculatePercentage(candidate, total) === value) {
    return candidate;
  }
  if (calculatePercentage(candidate, total) === value) {
    return candidate;
  }
  for (let i = 1; i <= 4; i++) {
    if (calculatePercentage(candidate + i, total) === value) {
      return candidate + i;
    }
  }
  for (let j = -4; j <= -1; j++) {
    if (calculatePercentage(candidate + j, total) === value) {
      return candidate + j;
    }
  }
  return candidate;
};
